import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const Blogs = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default Blogs;
